var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 70 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 20.5,
    width: 69,
    height: 47,
    rx: 5.5,
    fill: "#1F72CD",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5493 37L26 51.4935H33.8405L34.8125 49.1826H37.0342L38.0062 51.4935H46.6364V49.7298L47.4054 51.4935H51.8696L52.6386 49.6925V51.4935H70.587L72.7695 49.2426L74.813 51.4935L84.0317 51.5121L77.4617 44.2872L84.0317 37H74.956L72.8315 39.2093L70.8523 37H51.3268L49.6501 40.7409L47.9341 37H40.11V38.7037L39.2396 37H32.5493ZM59.3516 39.0581H69.6584L72.8108 42.4633L76.0648 39.0581H79.2172L74.4275 44.2852L79.2172 49.452H75.9218L72.7695 46.0073L69.4989 49.452H59.3516V39.0581ZM61.8968 43.1099V41.2114V41.2096H68.328L71.1342 44.2458L68.2036 47.2986H61.8968V45.226H67.5197V43.1099H61.8968ZM34.0664 39.0581H37.8883L42.2324 48.8862V39.0581H46.4191L49.7745 46.1048L52.8668 39.0581H57.0326V49.4581H54.4978L54.4771 41.3087L50.7817 49.4581H48.5142L44.7981 41.3087V49.4581H39.5836L38.595 47.1266H33.254L32.2675 49.4561H29.4736L34.0664 39.0581ZM34.166 44.9712L35.9256 40.8177L37.6832 44.9712H34.166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.d57b6ec631650a1caa5512386ce4a053.svg";
export { ForwardRef as ReactComponent };